import React from 'react'

const PageTitle = ({ content }) => {
  const { pageTitle } = content
  const titleWithHyphen = pageTitle.replace('-', '\xAD') ?? ''

  return (
    <div className='row justify-content-center'>
      <div className='col-10'>
        <h2 className='hdln--1 mt-4 t-align--center'>{titleWithHyphen}</h2>
      </div>
    </div>
  )
}

export default PageTitle
